import { Box, Link } from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid-pro";
import React from "react";
import { DataGridComponent } from "../common/DataGridComponent";

const columns = [
  {
    field: "sampleID",
    headerName: "Sample ID",
    minWidth: 140,
    flex: 1,
    renderCell: (params: any) => (
      <>
        <Link>{params.row.sampleID}</Link>
      </>
    ),
  },
  {
    field: "patientID",
    headerName: "Patient ID",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "collectionsite",
    headerName: "Collection Site",
    flex: 1,
  },
  {
    field: "studyID",
    headerName: "Study ID",
    minWidth: 140,
    flex: 1,
    renderCell: (params: any) => (
      <>
        <Link>{params.row.studyID}</Link>
      </>
    ),
  },
  {
    field: "type",
    headerName: "Type",
    flex: 1,
  },
  {
    field: "location",
    headerName: "Location",
    flex: 1,
  },
];

const initialRows = [
  {
    id: 1,
    sampleID: "S101",
    patientID: "3333-222",
    collectionsite: "S10010",
    studyID: "ONC-NSCLC-2024-01",
    type: "Stained Slide",
    location: "Lab#987",
  },
  {
    id: 2,
    sampleID: "S101",
    patientID: "3333-333",
    collectionsite: "S10020",
    studyID: "ONC-NSCLC-2024-01",
    type: "Unstained Slide",
    location: "Lab#987",
  },
  {
    id: 3,
    sampleID: "S101",
    patientID: "3333-222",
    collectionsite: "S10010",
    studyID: "ONC-NSCLC-2024-01",
    type: "Stained Slide",
    location: "Lab#987",
  },
  {
    id: 4,
    sampleID: "S101",
    patientID: "3333-333",
    collectionsite: "S10020",
    studyID: "ONC-NSCLC-2024-01",
    type: "Unstained Slide",
    location: "Lab#987",
  },
  {
    id: 5,
    sampleID: "S101",
    patientID: "3333-222",
    collectionsite: "S10010",
    studyID: "ONC-NSCLC-2024-01",
    type: "Stained Slide",
    location: "Lab#987",
  },
];

const SampleListDatagrid: React.FunctionComponent<any> = () => {
  const rows = initialRows;
  return (
    <>
      <Box
        sx={{
          width: "100%",
          minHeight: "50vh",
        }}
      >
        <DataGridComponent
          autoHeight
          columns={columns}
          rows={rows}
          slots={{ toolbar: GridToolbar }}
          checkboxSelection
          sx={{
            "&, [class^=MuiDataGrid]": { border: "none" },
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />
      </Box>
    </>
  );
};

export default SampleListDatagrid;
